import type { SxProps, Theme } from '@mui/material/styles';

const COLLAPSED_HEIGHT = 116;
// A percentage of the containing mapRegion's own height, not the viewport
// (`vh`) — the map area's actual available height varies with how much
// room the mobile controls row and legal disclaimer bar take up above/
// below it, and a viewport-relative height could overflow past the top of
// that container, getting clipped by its `overflow: hidden`.
const EXPANDED_HEIGHT = '88%';

export const mobileBottomSheetStyles: {
  root: (expanded: boolean) => SxProps<Theme>;
  handleButton: SxProps<Theme>;
  handleBar: SxProps<Theme>;
  handleIcon: SxProps<Theme>;
  tabs: SxProps<Theme>;
  tab: SxProps<Theme>;
  content: SxProps<Theme>;
  section: SxProps<Theme>;
} = {
  root: (expanded) => (theme) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 3,
    height: expanded ? EXPANDED_HEIGHT : COLLAPSED_HEIGHT,
    transition: 'height 220ms ease',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
    borderTopLeftRadius: theme.radius('card'),
    borderTopRightRadius: theme.radius('card'),
    boxShadow: theme.elevations.cardHover,
    overflow: 'hidden',
  }),
  handleButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0.25,
    paddingBlock: 1,
    borderRadius: 0,
    flexShrink: 0,
  },
  handleBar: (theme) => ({
    width: 36,
    height: 4,
    borderRadius: 999,
    backgroundColor: theme.palette.divider,
  }),
  handleIcon: (theme) => ({
    fontSize: 18,
    color: theme.palette.text.secondary,
    marginTop: -0.5,
  }),
  tabs: (theme) => ({
    flexShrink: 0,
    minHeight: 40,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTabs-indicator': { backgroundColor: theme.palette.primary.main },
  }),
  tab: (theme) => ({
    textTransform: 'none',
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '0.875rem',
    minHeight: 40,
    color: theme.palette.text.secondary,
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
    },
  }),
  content: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  section: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  }),
};
